class ConfirmSecondFactorEnrollment {
	constructor(public readonly code: string) {
		Object.freeze(this);
	}

	toJSON(): Record<string, unknown> {
		return {
			code: this.code,
		};
	}
}

export default ConfirmSecondFactorEnrollment;
